export default "__VITE_ASSET__9c343b3a__"